import React from "react";
import { Box, Typography } from "@mui/material";
import { FormattedMessage } from "react-intl";
import { EditProfileFields } from "../edit-profile-page/edit-profile-fields";
import { ProfilePageTutoringsBox } from "../profile-page-teachings/ProfilePageTutoringsBox";

export const ProfilePageContent = ({ profileSubdomain }) => {
  if (!profileSubdomain[2]) {
    return <ProfilePageTutoringsBox />;
  }

  switch (profileSubdomain[2]) {
    case "my-teachings":
      return <ProfilePageTutoringsBox />;
    case "edit":
      return <EditProfileFields />;
    case "my-groups":
      return (
        <Box sx={{ p: 3, textAlign: "center" }}>
          <Typography variant="h5" color="text.secondary">
            <FormattedMessage id="feature-coming-soon" />
          </Typography>
        </Box>
      );
    default:
      return <ProfilePageTutoringsBox />;
  }
};
